
define('ldsh!modules/lp_leads/templates/main', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<h3\n  class="ed-h-gamma"\n  data-i18n="common.leads"\n></h3>\n\n<div class="ed-table-container"></div>\n\n<ul class="ed-pagination">\n  ';
 if (currentPage > 1) { ;
__p += '\n    <li class="item nav-pag-first">\n      <a\n        href="javascript:void(0)"\n        class="js-pager-first"\n      >\n        <span class="ed-icon ed-icon-navfirst"></span>\n      </a>\n    </li>\n    <li class="item nav-pag-prev">\n      <a\n        href="javascript:void(0)"\n        class="js-pager-prev"\n      >\n        <span class="ed-icon ed-icon-navprev"></span>\n      </a>\n    </li>\n  ';
 } ;
__p += '\n  ';
 for(var i=startPage; i <= endPage; i++) { ;
__p += '\n    <li class=\'item' +
((__t = ( i === currentPage ? " is-current " : "" )) == null ? '' : __t) +
'\'>\n      <a href="javascript:void(0)" class="js-pager" data-page="' +
((__t = ( i )) == null ? '' : __t) +
'">' +
((__t = ( i )) == null ? '' : __t) +
'</a>\n    </li>\n  ';
 } ;
__p += '\n  ';
 if(currentPage < pageCount) { ;
__p += '\n    <li class="item nav-pag-next">\n      <a\n        href="javascript:void(0)"\n        class="js-pager-next"\n      >\n        <span class="ed-icon ed-icon-navnext"></span>\n      </a>\n    </li>\n    <li class="item nav-pag-last">\n      <a\n        href="javascript:void(0)"\n        class="js-pager-last"\n      >\n        <span class="ed-icon ed-icon-navlast"></span>\n      </a>\n    </li>\n  ';
};
__p += '\n</ul>\n<div class="ed-hero-actions">\n  <button\n    type="button"\n    class="btn--primary js-download"\n    data-i18n="landingPage.dialog.leadListing.downloadLeads"\n  ></button>\n</div>\n';

}
return __p
};});

